var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 239.13,
    viewBox: "0 0 46 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFB500",
    d: "M22.96 54.65c-1.42-.62-13.03-5.69-16.78-8.77C2.14 42.57 0 37.81 0 32.12V5.1C6.38 1.71 14.1 0 22.96 0c8.86 0 16.58 1.72 22.96 5.1v27.03c0 5.68-2.13 10.44-6.17 13.75-3.7 3.03-15.44 8.19-16.79 8.77zM38.3 50.8a1.93 1.93 0 000 3.85c1.07 0 1.93-.86 1.93-1.92a1.93 1.93 0 00-1.93-1.93zm1.6 1.93a1.59 1.59 0 11-3.18 0 1.59 1.59 0 013.17 0zm-1.66-.84c.36 0 .4.18.4.33 0 .22-.09.37-.54.37h-.06v-.7h.2zm-.62-.34v2.34h.42v-.97h.06c.04.04.64.97.64.97h.51l-.7-1.03c.3-.07.52-.3.52-.62 0-.34-.2-.7-.78-.7h-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#351C15",
    d: "M31.85 22.76c-.01-3.22 2.74-5.13 5.36-5.2 2.2-.07 3.69.76 4.39 1.3v3.47a5.35 5.35 0 00-3.58-1.64c-1.13-.01-2.31.49-2.35 1.9-.04 1.46 1.14 2.04 2.63 2.9 3.34 1.97 3.98 3.73 3.9 6.06-.07 2.56-1.83 5.35-5.78 5.35-1.58 0-3.14-.5-4.4-1.24v-3.68a6.37 6.37 0 003.83 1.63c1.46 0 2.43-.84 2.4-2.23-.04-1.25-.75-1.94-2.5-2.97-3.3-1.93-3.89-3.52-3.9-5.64zm-9.68-1.7c.33-.16.88-.28 1.42-.28 2.32 0 3.28 1.85 3.28 6.32 0 4.37-1.1 6.48-3.4 6.48a3.78 3.78 0 01-1.3-.24V21.06zm0 23.95h-4V18.98a9.66 9.66 0 015.39-1.42c4.77 0 7.39 3.62 7.39 9.44 0 5.83-2.55 9.83-6.98 9.83a6.3 6.3 0 01-1.8-.23v8.41zM4.15 30.51V17.97h3.99V30.7c0 1.13.27 2.8 2.1 2.8.82 0 1.46-.18 1.9-.48V17.96h3.98V35.3a10.6 10.6 0 01-6.02 1.6c-3.95 0-5.95-2.14-5.95-6.37zM2.1 32.14c0 5.03 1.86 9.24 5.4 12.12 3.12 2.55 12.74 6.9 15.45 8.1 2.68-1.18 12.27-5.48 15.45-8.1 3.56-2.93 5.4-7.04 5.4-12.12V5.67c-13.37-1.25-29.18-.48-41.7 11v15.46z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUps);
export default __webpack_public_path__ + "static/media/ups.6c24608fae478bb52fbd310d5640fe8a.svg";
export { ForwardRef as ReactComponent };